/* ═══════════════════════════════════════
   DrNewMed India — Theme JavaScript
   ═══════════════════════════════════════ */

/* FAQ Toggle */
function tf(id) {
  document.getElementById(id).classList.toggle('open');
}

/* Notify Me Modal */
function openNotify(e, name) {
  e.stopPropagation();
  document.getElementById('notifyProduct').textContent = name;
  document.getElementById('notifyTitle').textContent = 'Get Notified about ' + name;
  document.getElementById('notifyEmail').value = '';
  document.getElementById('notifyPopup').classList.add('active');
}

function closeNotify(e) {
  if (e.target === document.getElementById('notifyPopup')) {
    document.getElementById('notifyPopup').classList.remove('active');
  }
}

function submitNotify() {
  var email = document.getElementById('notifyEmail').value;
  if (email && email.includes('@')) {
    /*
      TODO: Connect to your email service (Klaviyo, Mailchimp, etc.)
      Example Klaviyo:
      fetch('https://a.klaviyo.com/api/v2/list/YOUR_LIST_ID/subscribe', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({api_key:'YOUR_KEY',profiles:[{email:email}]})
      });
    */
    document.querySelector('.notify-box').innerHTML =
      '<div style="padding:1rem">' +
        '<div style="font-size:2.5rem;margin-bottom:1rem">✅</div>' +
        '<div style="font-family:var(--hf);font-size:1.4rem;font-weight:900;color:var(--green);margin-bottom:.5rem">You\'re on the list!</div>' +
        '<p style="font-size:.875rem;color:var(--text-mid);font-family:var(--sf)">We\'ll email you the moment this product launches. Thank you!</p>' +
      '</div>';
    setTimeout(function () {
      document.getElementById('notifyPopup').classList.remove('active');
    }, 2500);
  }
}

/* Scroll fade-in animations */
document.addEventListener('DOMContentLoaded', function () {
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) {
          setTimeout(function () {
            e.target.classList.add('visible');
          }, i * 90);
        }
      });
    },
    { threshold: 0.1 }
  );
  document.querySelectorAll('.fade-up').forEach(function (el) {
    obs.observe(el);
  });

  /* Mobile menu toggle */
  var toggle = document.querySelector('.mobile-menu-toggle');
  var nav = document.querySelector('.nav-links');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('mobile-open');
    });
  }
});
